// extracted by mini-css-extract-plugin
var _1 = "#dfdcda";
var _2 = "ra-img-placeholder-box";
var _3 = "ra-img-placeholder";
var _4 = "ra-img-placeholder-loading";
export { _1 as "defaultImgPlaceholderBackground", _2 as "imgPlaceholderBoxCls", _3 as "imgPlaceholderCls", _4 as "imgPlaceholderLoadingCls" }
